(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaosugeridaDialogController', AquisicaosugeridaDialogController);

    AquisicaosugeridaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Aquisicaosugerida', 'Aquisicao', 'Receituario', 'Atividade', 'Propriedade'];

    function AquisicaosugeridaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Aquisicaosugerida, Aquisicao, Receituario, Atividade, Propriedade) {
        var vm = this;

        vm.aquisicaosugerida = entity;
        vm.clear = clear;
        vm.save = save;
        vm.aprovar = aprovar;
        vm.aquisicaos = Aquisicao.query();
        vm.receituarios = Receituario.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);

        }

        function save () {
            vm.isSaving = true;
            if (vm.aquisicaosugerida.id !== null) {
                Aquisicaosugerida.update(vm.aquisicaosugerida, onSaveSuccess, onSaveError);
            } else {
                Aquisicaosugerida.save(vm.aquisicaosugerida, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:aquisicaosugeridaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            history.go(-1);
        }

        function onSaveError () {
            vm.isSaving = false;
            history.go(-1);
        }

        function aprovar(id){
            var aq = new Aquisicao();
            aq.produtoaquisitado = vm.aquisicaosugerida.produtoaquisitado;
            aq.valor = vm.aquisicaosugerida.valor;
            aq.quantidade = vm.aquisicaosugerida.quantidade;
            aq.medida = vm.aquisicaosugerida.medidaquantidade;
            aq.dataaquisicao = new Date();
            aq.aquisicaosugerida = new Aquisicaosugerida();
            aq.aquisicaosugerida.id = vm.aquisicaosugerida.id;
            aq.atividade = new Atividade();
            aq.atividade.id = vm.aquisicaosugerida.receituario.atividade.id;
            aq.propriedade = new Propriedade();
            aq.propriedade.id = vm.aquisicaosugerida.receituario.atividade.etapa.safra.propriedade.id;
            Aquisicao.save(aq, onSaveSuccess, onSaveError);
            aq = null;
        }
    }
})();
